module.exports = __webpack_public_path__ + "static/img/37.fdb5c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ADDomain/37.png
// module id = VEKG
// module chunks = 1